import Mutations from '../../odata/mutations';

export default { ...new Mutations('task'), ...new Mutations('tasks') };
